(function () {
    'use strict';

    function phaseConfiguration() {
        return {
            restrict: 'E',
            templateUrl: 'siteConfiguration/directives/templates/phaseConfiguration.html',
            link: function (scope, element, attrs) {
            }
        };
    }

    phaseConfiguration.$inject = ['$http', '$compile'];

    angular.module('ecap.siteConfiguration').directive('phaseConfiguration', phaseConfiguration);
})();